import { render, staticRenderFns } from "./diagnosis-consultation-modal-consultation-personnel-info.vue?vue&type=template&id=a2eb9fd6&scoped=true&"
import script from "./diagnosis-consultation-modal-consultation-personnel-info.ts?vue&type=script&lang=ts&"
export * from "./diagnosis-consultation-modal-consultation-personnel-info.ts?vue&type=script&lang=ts&"
import style0 from "./diagnosis-consultation-modal-consultation-personnel-info.scss?vue&type=style&index=0&id=a2eb9fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eb9fd6",
  null
  
)

export default component.exports